import { create } from 'zustand';

interface PriceField {
  originalPrice: number;
  contentType: string;
  contentGenre: string;
  price: number;
  talentManagerCost: number;
  subsidyAmount: number;
  actualGet: number; // 达人实际到手金额
  bonusAmount?: number; // 按时提交奖金金额(会因为逾期等原因清零，多用来判断是否有奖金)
  originalBonusAmount?: number; // 原始按时提交奖金金额(不会因为逾期等原因清零，用在逾期申诉中显示奖金金额)
}

export enum GbPricingSchemaFlag {
  DISPLAY_PRICE_CANNOT_CHANGE = 'display_price_cannot_change',
  NOT_DISPLAY_PRICE_CAN_CHANGE = 'not_display_price_can_change',
  DISPLAY_PRICE_CAN_CHANGE = 'display_price_can_change'
}

type MultiplePricesStore = {
  gbPricingSchemaFlag: GbPricingSchemaFlag;
  setGbPricingSchemaFlag: (gbPricingSchemaFlag: GbPricingSchemaFlag) => void;
  priceFields: PriceField[];
  setPriceFields: (priceFields: PriceField[]) => void;
  selectedPriceFields: PriceField[];
  setSelectedPriceFields: (selectedPriceFields: PriceField[]) => void;
  creatorLowActualGet: number | null;
  creatorHighActualGet: number | null;
  creatorMaxActualGet: number | null;
  clearAllMultiplePricesStore: () => void;
  rateNonNegotiable: boolean;
  setRateNonNegotiable: (rateNonNegotiable: boolean) => void;
};

export const useMultiplePricesStore = create<MultiplePricesStore>()((set) => ({
  gbPricingSchemaFlag: GbPricingSchemaFlag.DISPLAY_PRICE_CANNOT_CHANGE,
  setGbPricingSchemaFlag: (gbPricingSchemaFlag: GbPricingSchemaFlag) =>
    set({ gbPricingSchemaFlag }),
  priceFields: [],
  setPriceFields: (priceFields: PriceField[]) => set({ priceFields }),
  selectedPriceFields: [],
  setSelectedPriceFields: (selectedPriceFields: PriceField[]) =>
    set({ selectedPriceFields }),
  creatorLowActualGet: null,
  creatorHighActualGet: null,
  creatorMaxActualGet: null,
  clearAllMultiplePricesStore: () =>
    set({
      priceFields: [],
      selectedPriceFields: [],
      creatorLowActualGet: null,
      creatorHighActualGet: null,
      creatorMaxActualGet: null
    }),
  rateNonNegotiable: false,
  setRateNonNegotiable: (rateNonNegotiable: boolean) =>
    set({ rateNonNegotiable })
}));
